import React from "react";

import Image from "../image/Image.tsx";
import { Size } from "../../logic/enums.ts";

const DeterministicAvatar = ({
  string,
  size = Size.Medium,
  additionalClasses = "",
}) => {
  const decimalHash = (string) => {
    let sum = 0;
    for (let i = 0; i < string.length; i++)
      sum += ((i + 1) * string.codePointAt(i)) / (1 << 8);
    return sum % 1;
  };

  const integerHash = (string) => {
    return Math.floor(decimalHash(string) * 1000);
  };

  const hash = integerHash(string);
  const animalIndex = hash % 10;
  const colorIndex = hash % 8;

  const faAnimals = [
    "fa-dog",
    "fa-cat",
    "fa-dove",
    "fa-dragon",
    "fa-frog",
    "fa-hippo",
    "fa-crow",
    "fa-otter",
    "fa-horse",
    "fa-fish",
  ];

  const colors = [
    "bg-blue-700",
    "bg-green-700",
    "bg-yellow-700",
    "bg-purple-700",
    "bg-pink-700",
    "bg-orange-700",
    "bg-teal-700",
    "bg-indigo-700",
  ];

  let textSizeClass = "text-2xl";
  switch (size) {
    case Size.Small:
      textSizeClass = "text-sm";
      break;
    case Size.Medium:
      textSizeClass = "text-2xl";
      break;
    case Size.Large:
      textSizeClass = "text-4xl";
      break;
    case Size.Huge:
      textSizeClass = "text-5xl";
      break;
  }

  return (
    <div
      className={`flex flex-col items-center justify-center aspect-square rounded-full ${colors[colorIndex]} ${additionalClasses}`}
    >
      <i
        className={`text-white ${textSizeClass} fa-solid ${faAnimals[animalIndex]}`}
      />
    </div>
  );
};

const CorporateDetail = () => {
  return (
    <div className="w-full h-full absolute border-2 rounded-full p-2 border-red-400" />
  );
};

const AccountAvatar = ({
  presignedUrl,
  username = "",
  isSmall = false,
  isLarge = false,
  isHuge = false,
  isCorporate = false,
}) => {
  let sizeClass = "h-[55px] aspect-square";
  let size = Size.Medium;

  if (isSmall) {
    size = Size.Small;
    sizeClass = "h-9 aspect-square";
  }

  if (isLarge) {
    size = Size.Large;
    sizeClass = "h-20 aspect-square";
  }

  if (isHuge) {
    size = Size.Huge;
    sizeClass = "h-24 md:h-32 aspect-square";
  }

  const imageScale = isCorporate ? "scale-[80%]" : "scale-100";

  return (
    <div className="flex flex-col items-center justify-center border relative aspect-square rounded-full  ">
      {isCorporate && <CorporateDetail />}
      {presignedUrl && (
        <Image
          id={"account-img"}
          src={presignedUrl}
          alt="#"
          className={`flex rounded-full  ${sizeClass} relative ${imageScale}`}
        />
      )}
      {!presignedUrl && (
        <DeterministicAvatar
          string={username}
          size={size}
          additionalClasses={sizeClass}
        />
      )}
    </div>
  );
};

export default AccountAvatar;
